import React from "react";
import GalleryWrapper2 from "./GalleryWrapper2";

function GalleryPage() {
  return (
    <>
        <GalleryWrapper2/>
    </>
  )
}

export default GalleryPage